import { Gmeet, Teams, Zoom } from '@/assets/icons/location';
import { Hackerrank } from '@/assets/icons/ats';
import { Phone } from '@kula-ai/icons/outline/Phone';
import { Building07 } from '@kula-ai/icons/outline/Building07';

type MeetingLocationValue =
  | 'zoom'
  | 'google_meet'
  | 'teams'
  | 'hackerrank'
  | 'phone_interview'
  | 'onsite';

export interface MeetingLocationOption {
  label: string;
  value: MeetingLocationValue;
  icon: any;
  isAvailable?: boolean;
}

export const meetingLocationUiOptions: MeetingLocationOption[] = [
  { label: 'Zoom', value: 'zoom', icon: Zoom },
  { label: 'Google', value: 'google_meet', icon: Gmeet },
  { label: 'Teams', value: 'teams', icon: Teams },
  { label: 'HackerRank', value: 'hackerrank', icon: Hackerrank },
  { label: 'Phone interview', value: 'phone_interview', icon: Phone },
  { label: 'Onsite / Physical', value: 'onsite', icon: Building07 },
];
